module.exports = __webpack_public_path__ + "img/carrito.309fc28d.png";